const CLOUD_NAME = 'dsh0tsol7';

export function galleryThumbnailUrl(imageRef: string, size = 320): string {
  return `https://res.cloudinary.com/${CLOUD_NAME}/image/upload/c_fill,w_${size},h_${size},g_auto,q_auto,f_auto/${imageRef}`;
}
